package diana.soleil.design.iraniancanadienbazzar.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.AppError
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.SignInStatus
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.SignUpScreen
import org.koin.compose.viewmodel.koinViewModel

/**
 * Stateful host for [SignUpScreen]: owns [AuthViewModel], runs registration (create account + set
 * display name) and maps [AppError] onto the screen's [SignInStatus]. When a real (non-anonymous)
 * session appears, the account was created and we navigate on via [onAuthenticated].
 */
@Composable
fun SignUpRoute(
    onAuthenticated: () -> Unit,
    onSignIn: () -> Unit,
    onBack: () -> Unit,
    viewModel: AuthViewModel = koinViewModel(),
) {
    val ui by viewModel.ui.collectAsStateWithLifecycle()
    val session by viewModel.session.collectAsStateWithLifecycle()

    LaunchedEffect(session) {
        if (session?.isAnonymous == false) onAuthenticated()
    }

    SignUpScreen(
        onSubmit = { name, email, password -> viewModel.signUp(name, email, password) },
        onGoogle = if (viewModel.googleSignInAvailable) viewModel::signInWithGoogle else null,
        onApple = if (viewModel.appleSignInAvailable) viewModel::signInWithApple else null,
        onSignIn = onSignIn,
        onBack = onBack,
        isLoading = ui.loading,
        status = ui.toSignUpStatus(),
    )
}

private fun AuthUiState.toSignUpStatus(): SignInStatus? = when (error) {
    null -> null
    is AppError.Conflict -> SignInStatus.EmailInUse
    is AppError.InvalidCredentials -> SignInStatus.InvalidCredentials
    is AppError.Network -> SignInStatus.Network
    else -> SignInStatus.Generic
}
